module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_8017.9a43cdcd.png";